import { render, staticRenderFns } from "./RoApcnPopupTableInfo4.vue?vue&type=template&id=372dcffc&"
import script from "./RoApcnPopupTableInfo4.vue?vue&type=script&lang=js&"
export * from "./RoApcnPopupTableInfo4.vue?vue&type=script&lang=js&"
import style0 from "./RoApcnPopupTableInfo4.vue?vue&type=style&index=0&id=372dcffc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports